import { render } from "./CreateNewCheckList.vue?vue&type=template&id=f51130f2&scoped=true"
import script from "./CreateNewCheckList.vue?vue&type=script&lang=js"
export * from "./CreateNewCheckList.vue?vue&type=script&lang=js"

import "./CreateNewCheckList.vue?vue&type=style&index=0&id=f51130f2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f51130f2"]])

export default __exports__